<template>
  <div class="switch-container mr-2">
    <div class="center con-switch">
      <vs-switch
        class="vs-switch-success"
        @click="ChangeStatus"
        v-model="actiobBtn"
      />
    </div>
  </div>
</template>
<script>
export default {
  mounted () {
    this.actiobBtn = this.params.data.status
  },
  data () {
    return {
      actiobBtn: false
    }
  },
  methods: {
    ChangeStatus () {
      // console.log(this.params.rowIndex)
      this.params.colDef.filterParams.changeStatus(
        this.actiobBtn,
        this.params.data.id,
        this.params.rowIndex,
      )
    }
  }
}
</script>
